import { TextSelection } from '@atlaskit/editor-prosemirror/state';
import { selectionToolbarPluginKey } from './plugin-key';
export var toggleToolbar = function toggleToolbar(_ref) {
  var hide = _ref.hide;
  return function (_ref2) {
    var tr = _ref2.tr;
    tr.setMeta(selectionToolbarPluginKey, {
      hide: hide
    });
    return tr;
  };
};
export var setToolbarDocking = function setToolbarDocking(_ref3) {
  var toolbarDocking = _ref3.toolbarDocking,
    userPreferencesProvider = _ref3.userPreferencesProvider;
  return function (_ref4) {
    var tr = _ref4.tr;
    // We currently ignore any update failures, need to confirm this is the desired behaviour
    userPreferencesProvider === null || userPreferencesProvider === void 0 || userPreferencesProvider.updatePreference('toolbarDockingInitialPosition', toolbarDocking);
    tr.setMeta(selectionToolbarPluginKey, {
      toolbarDocking: toolbarDocking
    });
    if (toolbarDocking === 'top') {
      // Remove the selection if the toolbar is docked to the top
      tr.setSelection(TextSelection.create(tr.doc, tr.selection.head));
    }
    return tr;
  };
};